"use client";
import { useUser } from "@auth0/nextjs-auth0/client";
import { Box, Button, Image, Text, Tooltip } from "@mantine/core";
import Link from "next/link";
import React from "react";
import { useTranslation } from "react-i18next";

import cardStyles from "@/components/general/card/card.module.css";
import { EscapeRoomProps } from "@/components/types";
import { useStateContext } from "@/context/context-provider";
import { useSocketContext } from "@/context/socket-context-provider";
import { useUserContext } from "@/context/user-context-provider";

import styles from "./room-display.module.css";

const RoomDisplay = ({ room }: { room: EscapeRoomProps }) => {
    const { user: session } = useUser();
    const { isMobile } = useStateContext();
    const { t } = useTranslation();

    const { user } = useUserContext();
    const { lobbyId, socket } = useSocketContext();

    return (
        <Box className={`${cardStyles.card} ${styles.roomDisplay}`}>
            <Image src={room.image} alt={room.title} radius="lg" width={600} className={styles.image} />
            <Text className="description" c="var(--mantine-color-gray-6)">
                {room.description}
            </Text>
            <ul>
                <li>
                    {t("details.room.difficulty")}: {t(`details.room.difficultyLevels.${room.difficulty}`)}
                </li>
                <li>
                    {t("details.room.time")}: ~{room.time} min.
                </li>
            </ul>
            {/* Buttons */}

            {user?.escaperooms.includes(room.id) || lobbyId || room?.price === 0 ? (
                <Tooltip disabled={!isMobile} label={isMobile ? t("details.room.tooltipMobile") : null} withArrow>
                    <Button
                        radius="md"
                        lts=".06rem"
                        mt="auto"
                        size="lg"
                        component={isMobile ? "button" : Link}
                        href={lobbyId ? `/escape-room/${room.url}?lobby=${lobbyId}` : `/escape-room/${room.url}`}
                        disabled={isMobile}
                        onClick={() => {
                            if (socket && lobbyId) {
                                socket.emit("startLobby", { lobbyId, room: room.url });
                            }
                        }}>
                        {t("details.room.start")}
                    </Button>
                </Tooltip>
            ) : (
                <Tooltip disabled={!!session} label={session ? null : t("details.room.tooltipNotLoggedIn")} withArrow>
                    <Button
                        radius="md"
                        lts=".06rem"
                        mt="auto"
                        size="lg"
                        component={session ? Link : "button"}
                        disabled={!session}
                        href={session ? `${room?.paymentUrl}?prefilled_email=${session.email}&client_reference_id=${session.email}` : "#"}>
                        {t("details.room.purchase", { price: room.price })}
                    </Button>
                </Tooltip>
            )}
        </Box>
    );
};

export default RoomDisplay;
